const MapLayer = {
    Regulatory: 'regulatory',
    Area: 'area',
    Fuels: 'fuels',
    Incentive: 'incentive'
};

const MapRegulatoryGroup = {
    Region: 'region',
    Country: 'country',
    State: 'state',
    Port: 'port'
};

const MapAreaGroup = {
    ECA: 'eca',
    PSSA: 'pssa',
    SpecialOil: 'sp_oil',
    SpecialSewage: 'sp_sewage',
    SpecialGarbage: 'sp_garbage'
};

const PortStateControlRisk = {
    Low: {
        Id: 3,
        Color: '#418cd1'
    },
    Medium: {
        Id: 2,
        Color: '#FFAD0A'
    },
    High: {
        Id: 1,
        Color: '#DA1F33'
    }
};

export default {
    MapLayer,
    MapRegulatoryGroup,
    MapAreaGroup,
    PortStateControlRisk
};
